import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {CallJs} from "../lib/types";
import {createStore} from "redux";
import {withDefault} from "../lib/utils";
import {
	OrdersFiltersApp, OrdersFiltersStore,
	OwnProps as OrdersFiltersOwnProps
} from "./orders-filters/app";
import {reducer as ordersFiltersReducer, State as OrdersFiltersState} from "./orders-filters/reducers";
import {
	DateType, GeoState, GeoStates, OrderStatus, Origin, Origins, PaidStatus, PaymentGroup, PaymentGroups, PaymentMethod,
	PaymentMethods
} from "./orders-filters/data";

type OrdersFiltersParams = {
	selectedOrderStatus: OrderStatus
	selectedPaidStatus: PaidStatus
	selectedPaymentMethod: PaymentMethod
	selectedOrigin: Origin
	selectedState: GeoState
	selectedPaymentGroup: PaymentGroup
	selectedDateType: DateType
	fromDate?: number
	toDate?: number

	paymentMethods: PaymentMethods
	origins: Origins
	states: GeoStates
	paymentGroups: PaymentGroups
}

export const ordersFiltersCallJs:CallJs<OrdersFiltersParams> = (replace, params) => {
	const ownProps = (store: OrdersFiltersStore): OrdersFiltersOwnProps => ({
		store: store,
		paymentMethods: params.paymentMethods,
		origins: params.origins,
		states: params.states,
		paymentGroups: params.paymentGroups,
	})

	const fromDate = params.fromDate !== undefined ? new Date(params.fromDate * 1000) : null
	const toDate = params.toDate !== undefined ? new Date(params.toDate * 1000) : null

	const initialState: OrdersFiltersState = {
		selectedOrderStatus: params.selectedOrderStatus,
		selectedPaidStatus: params.selectedPaidStatus,
		selectedPaymentMethod: params.selectedPaymentMethod,
		selectedOrigin: params.selectedOrigin,
		selectedState: params.selectedState,
		selectedPaymentGroup: params.selectedPaymentGroup,
		selectedDateType: fromDate !== null || toDate !== null ? params.selectedDateType : 'any',
		fromDate: fromDate,
		toDate: toDate,
	}

	const div = document.createElement('div')
	replace(div)

	const store = createStore(withDefault(ordersFiltersReducer, initialState), initialState)
	ReactDOM.render(<OrdersFiltersApp {...ownProps(store)}/>, div)
}



// WEBPACK FOOTER //
// ./src/orders2/orders-filters.tsx